import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Colaborador, ColaboradorDocumento } from '../page/colaborador/colaborador';

@Injectable({ providedIn: 'root' })
export class ColaboradorService {

  private apiURL = environment.apiBaseUrl + 'colaborador';

  constructor(private http: HttpClient) { }

  listar(): Observable<Colaborador[]> {
    return this.http.get<Colaborador[]>(this.apiURL);
  }

  listarAtivos(): Observable<Colaborador[]> {
    return this.http.get<Colaborador[]>(`${this.apiURL}/ativos`);
  }

  buscarPorId(id: number): Observable<Colaborador> {
    return this.http.get<Colaborador>(`${this.apiURL}/${id}`);
  }

  salvar(colaborador: Colaborador): Observable<Colaborador> {
    if (colaborador.id) {
      return this.http.put<Colaborador>(`${this.apiURL}/${colaborador.id}`, colaborador);
    }
    return this.http.post<Colaborador>(this.apiURL, colaborador);
  }

  inativar(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiURL}/${id}`);
  }

  listarDocumentos(colaboradorId: number): Observable<ColaboradorDocumento[]> {
    return this.http.get<ColaboradorDocumento[]>(`${this.apiURL}/${colaboradorId}/documentos`);
  }

  anexarDocumento(colaboradorId: number, arquivo: File): Observable<ColaboradorDocumento> {
    const form = new FormData();
    form.append('arquivo', arquivo);
    return this.http.post<ColaboradorDocumento>(`${this.apiURL}/${colaboradorId}/documentos`, form);
  }

  baixarDocumento(colaboradorId: number, documentoId: number): Observable<Blob> {
    return this.http.get(`${this.apiURL}/${colaboradorId}/documentos/${documentoId}`, { responseType: 'blob' });
  }

  removerDocumento(colaboradorId: number, documentoId: number): Observable<void> {
    return this.http.delete<void>(`${this.apiURL}/${colaboradorId}/documentos/${documentoId}`);
  }
}
